<template>
	<v-row justify="center">
		<v-col cols="12" md="6" lg="4" xl="3">
			<v-card class="mb-16">
				<v-card-text class="px-8">
					<div class="d-flex align-center mb-6 py-4">
						<v-img class="mr-5" max-width="4rem" height="4rem" :src="__logo"></v-img>
						<h2 class="display-2 black--text mb-0">Welcome</h2>
					</div>
					<div v-if="step === 'code'" class="mb-6">
						<div class="mb-4">
							{{ challenge.method === 'google'
								? 'Enter the code from Google Authenticator.'
								: 'We sent a sign-in code to ' + challenge.email + '.' }}
						</div>
						<v-text-field
							label="Verification code"
							placeholder="6-digit code"
							v-model="code"
							name="code"
							inputmode="numeric"
							autocomplete="one-time-code"
							maxlength="6"
							@keyup.enter="verify()"
						></v-text-field>
						<v-btn
							@click="verify()"
							:loading="loading"
							block
							color="primary"
							class="mb-2"
						>
							Verify
						</v-btn>
						<v-btn
							v-if="challenge.method === 'email'"
							@click="resend()"
							:loading="resending"
							:disabled="resending"
							text
							block
						>
							Resend code
						</v-btn>
						<v-btn @click="back()" text block>Back</v-btn>
					</div>
					<template v-else>
						<div class="mb-6">
							<v-text-field
								label="Email"
								placeholder="Enter Email"
								v-validate="obj.rules.email"
								v-model="obj.values.email"
								name="email"
								:error-messages="errors.collect('email')"
								data-vv-as="Email"
							></v-text-field>
							<v-text-field
								label="Password"
								placeholder="Enter Password"
								type="password"
								v-validate="obj.rules.password"
								v-model="obj.values.password"
								name="password"
								:error-messages="errors.collect('password')"
								data-vv-as="Password"
							></v-text-field>
						</div>

						<v-btn
							@click="sign()"
							:loading="loading"
							block
							color="primary"
							class="mb-4"
						>
							Sign In
						</v-btn>
					</template>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
import Main from "../../../mixins/Main";
import Login from "../models/Login";

export default {
	name: 'Login',
	mixins: [Main],
	data(){
		return {
			obj: new Login(),
			loading: false,
			resending: false,
			step: 'credentials',
			challenge: null,
			code: ''
		}
	},
	methods: {
		sign(){
			this.$validator.validateAll().then(valid => {
				if (valid){
					this.loading = true;
					this.obj.create(this.__authApiPath + 'login')
						.then(response => {
							const data = response.data.data || {};
							if (data.two_factor) {
								this.loading = false;
								this.challenge = data;
								this.code = '';
								this.step = 'code';
								return;
							}
							window.location = this.__afterAuthPath;
						})
						.catch(error => {
							this.loading = false;
							this.__errorResponse(error)
						})
				}
			})
		},
		verify(){
			if (!/^\d{6}$/.test(this.code || '')) {
				this.__error('Enter the 6-digit code.');
				return;
			}
			this.loading = true;
			axios.post(this.__authApiPath + 'login/two-factor', {code: this.code})
				.then(() => window.location = this.__afterAuthPath)
				.catch(error => {
					this.loading = false;
					this.__errorResponse(error);
				})
		},
		resend(){
			this.resending = true;
			axios.post(this.__authApiPath + 'login/two-factor/email')
				.then(response => this.__info(response.data.message))
				.catch(error => this.__errorResponse(error))
				.finally(() => {
					this.resending = false;
				})
		},
		back(){
			this.step = 'credentials';
			this.challenge = null;
			this.code = '';
		}
	}
}
</script>
